<template>
  <dashboard-topbar/>
  <div class="register">
    <div class="row">
      <div class="col-xs-12 col-md-12 col-lg-6">
        <div class="auth-block">
          <div class="form-label-block">
            <div class="title">
              <h1>{{ $t('Signup') }}</h1>
            </div>
            <div class="description">
              {{ $t('ConfirmYourPhoneNumberToRegister') }}
            </div>
          </div>
          <div class="form-phone-block">
            <form @submit.prevent="onSubmit" autocomplete="off">
              <div :hidden="isCodeSend" class="mb-3">
                <div class="phone-label">
                  <label for="phone" class="form-label">{{ $t('PhoneNumber') }}</label>
                  <div class="form-check form-check-right">
                    <input class="form-check-input" type="checkbox" id="isPhoneOtherCountry"
                           v-model="isPhoneOtherCountry">
                    <label class="form-check-label" for="isPhoneOtherCountry">
                      {{ $t('AnotherCountry') }}
                    </label>
                  </div>
                </div>
                <div class="form-input">
                  <input type="text"
                         name="phone"
                         class="form-control input-dirty" :class="!isPhoneOtherCountry ? 'show' : 'hide'"
                         placeholder="+38 (___) ___-__-__"
                         id="phone"
                         v-model="phone"
                         aria-describedby="phone"
                         :disabled="isSubmitting"
                  >
                  <input type="text"
                         name="raw_phone"
                         class="form-control input-dirty" :class="isPhoneOtherCountry ? 'show' : 'hide'"
                         placeholder="+____________"
                         id="raw_phone"
                         v-model="raw_phone"
                         aria-describedby="raw_phone"
                         :disabled="isSubmitting"
                  >
                  <div class="form-text" :class="isPhoneInvalid ? 'danger' : 'normal'">{{ phoneMsg }}</div>
                </div>
              </div>
              <div :hidden="!isCodeSend" class="form-input mb-3">
                <label for="code" class="form-label">{{ $t('Code') }}</label>
                <input type="text"
                       name="code"
                       class="form-control input-dirty"
                       placeholder="______"
                       id="code"
                       v-model="code"
                       aria-describedby="code"
                       :disabled="isSubmitting"
                >
                <div class="form-text" :class="isCodeInvalid ? 'danger' : 'normal'">{{ codeMsg }}</div>
              </div>
              <div class="mt-4">
                <button class="btn btn-success" :disabled="isSubmitting">{{ $t('Continue') }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-12 col-lg-6">
        <div class="login-block">
          <h3>{{ $t('signupPage.rightBlock.title') }}</h3>
          <ul>
<!--            <li>-->
<!--              {{ $t('signupPage.rightBlock.item_1') }}-->
<!--              <span class="info-asterisk">*</span>-->
<!--            </li>-->
            <li>
              {{ $t('signupPage.rightBlock.item_2') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_3') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_4') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_5') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_6') }}
            </li>
          </ul>
<!--          <div class="section-desc info-asterisk-container">-->
<!--            <div class="info-asterisk">*</div>-->
<!--            <div class="info-asterisk__info">-->
<!--              <p>-->
<!--                {{ $t('signupPage.rightBlock.item_7') }}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
          <hr>
          <strong>{{ $t('AlreadyRegistered') }}</strong>
          <router-link class="btn btn--not-accent mt-10" :to="{name: 'login'}">
            {{ $t('Signin') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Inputmask from "inputmask"
  import {actionTypes, mutationTypes} from "@/store/modules/auth";
  import {mapState} from "vuex";
  import DashboardTopbar from "@/components/Topbar.vue";

  export default {
    name: 'DashboardSignup',
    components: {
      DashboardTopbar
    },
    data() {
      return {
        csrf: '',
        phone: '',
        raw_phone: '',
        isPhoneOtherCountry: false,
        code: ''
      }
    },
    mounted() {
      this.$nextTick(function () {
        let phoneSelector = document.getElementById("phone");
        if (JSON.stringify(phoneSelector) !== "null"){
          let maskPhone = new Inputmask({ mask: "+38 (999) 999-99-99", greedy: false})
          maskPhone.mask(phoneSelector)
        }
        let codeSelector = document.getElementById("code");
        if (JSON.stringify(codeSelector) !== "null"){
          let maskCode = new Inputmask({ mask: "999999", greedy: false})
          maskCode.mask(codeSelector)
        }
      })
      this.csrf = document.getElementById('app').dataset.csrf;
      this.$store.dispatch(actionTypes.setCsrf, this.csrf);

      this.$store.commit(mutationTypes.setPhoneMsg, this.$t("EnterYourPhoneNumber"));
      this.$store.commit(mutationTypes.setCodeMsg, this.$t("EnterCodeFromSms"));
    },
    methods: {
      onSubmit() {
        if (this.codeClean === ''){
          // Ony for phone enter
          if (this.phoneClean.length < 12) {
            this.$store.commit(mutationTypes.setIsPhoneInvalid, true);
          } else {
            // Send snm for phone
            this.$store.dispatch(actionTypes.sendCode, {phone: this.phoneClean, csrf: this.csrf})
          }
        } else if (this.codeClean.length < 6){
          this.$store.commit(mutationTypes.setIsCodeInvalid, true);
        } else {
          // Auth by phone sms code
          this.$store
              .dispatch(actionTypes.authByCode, {phone: this.phoneClean, code: this.codeClean, csrf: this.csrf})
              .then(data => {
                console.log("Auth Success")
                if (data['token'] !== undefined && data['token'] !== ''){
                  this.$router.push({name: 'dashboard'})
                }
          })
        }

      }
    },
    computed: {
      ...mapState({
        isSubmitting: state => state.auth.isSubmitting,
        phoneMsg: state => state.auth.phoneMsg,
        isPhoneInvalid: state => state.auth.isPhoneInvalid,
        isCodeInvalid: state => state.auth.isCodeInvalid,
        isCodeSend: state => state.auth.isCodeSend,
      }),
      codeMsg() {
        let msg = this.$store.state.auth.codeMsg
        if (msg && this.isCodeInvalid === false && this.isCodeSend === true && this.phone){
          return `${msg} ${this.phone}`
        }
        return msg
      },
      phoneClean(){
        let phone = ''
        let phone_str = this.phone
        if (this.isPhoneOtherCountry){
          phone_str = this.raw_phone
        }
        let phoneItems = phone_str.match(/[0-9]+/g)
        if (phoneItems === null) {
          return ''
        }
        phoneItems.forEach(function(i) {
          phone += i;
        })
        return phone
      },
      codeClean(){
        let code = ''
        let codeItems = this.code.match(/[0-9]+/g)
        if (codeItems === null) {
          return ''
        }
        codeItems.forEach(function(i) {
          code += i;
        })
        return code
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .hide{
    display: none !important;
  }
  .show{
    display: block !important;
  }

  .register {
    overflow-x: hidden;
    .title {
      padding-top: 30vh;
      margin-bottom: 10px;
      @media only screen and (max-width: $max-width-tablet) {
        padding-top: 90px;
      }
    }
    .description{
      margin-bottom: 40px;
    }
    .form-label-block{
      display: flex;
      flex-direction: column
    }
    .form-phone-block{
      display: flex;
      .btn{
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        font-family: DIN\ 2014,sans-serif;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        transition: color .3s ease;
        width: 100%;
        -webkit-appearance: none;
        background: $btn-cart;
        color: $bg-100;
      }
      .form-input {
        input {
          line-height: 1;
          padding: 0 40px 0 16px;
          outline: none;
          display: block;
          width: 100%;
          appearance: none;
          background: #fbf8f8;
          border: 1px solid transparent;
          border-radius: 3px;
          font-family: DIN\ 2014, sans-serif;
          height: 40px;
          transition: border .3s ease;
          max-width: unset !important;
        }
      }
      .form-check-right{
        display: flex;
        justify-content: right;
        label{
          padding-left: 8px;
        }
      }
      .phone-label{
        display: flex;
        justify-content: space-between;
      }
    }
    .auth-block{
      margin-bottom: 20px;
       @media only screen and (min-width: $max-width-laptop-large) {
        margin-left: 28vw;
      }
      @media only screen and (max-width: $max-width-laptop-large) and (min-width: $max-width-laptop) {
        margin-left: 18vw;
      }
      @media only screen and (max-width: $max-width-laptop) and (min-width: $max-width-tablet) {
        margin-left: 9vw;
      }
      @media only screen and (max-width: $max-width-tablet) and (min-width: $max-width-tablet-small) {
        margin-left: 30vw;
      }
      @media only screen and (max-width: $max-width-tablet-small) and (min-width: $max-width-mobile){
        margin-left: 9vw;
      }
      @media only screen and (max-width: $max-width-mobile){
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    .login-block{
      display: flex;
      flex-direction: column;
      padding-top: 30vh;
      padding-bottom: 40px;
      padding-left: 100px;
      padding-right: 225px;
      height: 100vh;
      background-color: $bd-y-gray;
      @media only screen and (max-width: $max-width-laptop) {
        padding-left: 50px;
        padding-right: 100px;
        height: 100vh;
      }
      @media only screen and (max-width: $max-width-tablet) {
        padding-top: 30px;
      }
      @media only screen and (max-width: $max-width-mobile) {
        padding-top: 30px;
        padding-left: 10px;
        padding-right: 10px;
        height: auto;
      }
      .info-asterisk-container{
        display: flex;
        font-size: 14px;
      }
      .btn{
        max-width: 280px;
      }
      ul {
          display: block;
          list-style-type: disc;
          margin-block-start: 1em;
          margin-block-end: 1em;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          padding-inline-start: 40px;
      }
      ul li {
        font-size: 14px;
        line-height: 18px;
        padding-bottom: 10px;
      }
      ul li:before {
          background: $danger;
          content: "";
          display: block;
          height: 8px;
          left: 0;
          position: absolute;
          top: 4px;
          width: 2px;
      }
    }
    #phone, #password {
      max-width: 200px;
    }

    .danger {
      color: $danger;
    }

    .normal {
      color: $fd;
    }
  }
</style>
